import * as React from 'react';
import { useAsync } from 'react-async-hook';
import RouteError from '../../../routing/RouteError';
import LoadingIndicatorFull from '../../components/LoadingIndicatorFull';

export const withInjector = <T extends { $injector: any }>(ComposedComponent: React.ComponentType<T>) => {
    const WithInjector: React.FC<Omit<T, '$injector'>> = props => {
        const { result: $injector, error } = useAsync(
            () => import(/* webpackChunkName: 'AngularModule' */ '../../../module').then(module => module.$injector),
            []
        );

        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return <RouteError />;
        }

        if ($injector) {
            return <ComposedComponent {...(props as any)} $injector={$injector} />;
        }

        return <LoadingIndicatorFull />;
    };

    return WithInjector;
};
